import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ThumbUpOutlineIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ThumbUpOutlineIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ThumbUpOutlineIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ThumbUpOutlineIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ThumbUpOutlineIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M8.647.034c.424.02.847.164 1.173.542.263.305.403.73.403 1.262l-.003.513-.015.658-.019.374-.028.33c-.033.312-.08.567-.148.796l-.022.065.069.091c.289.364.59.477 1.119.496l.15.003h.251c.682 0 1.239.08 1.679.286.37.175.624.435.726.876.07 2.43-.78 5.856-1.727 6.803a3.787 3.787 0 01-.494.433c-.39.278-.697.388-1.434.434l-.344.017-.405.01-.71.009c-1.71 0-2.668-.214-4.006-.754l-.393-.158a1.468 1.468 0 01-1.36.912H1.53c-.81 0-1.468-.657-1.468-1.468V7.5c0-.81.657-1.468 1.468-1.468h1.58c.443 0 .84.196 1.11.506.097-.236.216-.453.359-.635.21-.266.434-.459.881-.79l.286-.213c.973-.745 1.316-1.249 1.316-2.158l.005-.264c.028-.685.165-1.227.4-1.635.304-.526.745-.77 1.132-.808zM8.615.71l.027.003-.05.008c-.171.042-.377.18-.54.46-.199.347-.313.86-.313 1.56l-.005.202c-.054 1.114-.572 1.755-1.776 2.645l-.237.175-.23.182c-.168.138-.28.25-.381.377-.265.337-.448.94-.533 1.415v4.697l.539.216c1.172.473 2.01.675 3.414.702l.334.003.855-.012.335-.01.28-.016.122-.01.213-.025.177-.033a1.34 1.34 0 00.344-.126l.118-.072.06-.04c.12-.086.248-.2.406-.36.788-.787 1.597-4.044 1.54-6.234-.036-.148-.145-.259-.346-.354-.33-.154-.8-.222-1.39-.222h-.253c-.94-.005-1.484-.228-1.998-1.036l-.092-.145.062-.16c.11-.282.175-.626.21-1.134l.02-.363.012-.419.006-.746c0-.378-.087-.645-.238-.82C9.127.81 8.87.722 8.615.71zm-5.505 6H1.529a.79.79 0 00-.79.79v5.064c0 .437.354.79.79.79h1.58a.79.79 0 00.791-.79V7.5a.79.79 0 00-.79-.79z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ThumbUpOutlineIcon.displayName = "ThumbUpOutlineIcon";
export default ThumbUpOutlineIcon;
